/* IMENHOF BLOOM — cart-undo.js
   In-place "Ongedaan maken" na verwijderen. De verwijderde regel verandert
   op zijn eigen plek in een herstel-strook met aflopende voortgangsbalk.
   - window.ImhUndo.mountRow(slot, opts): gedeeld door winkelwagenpagina + drawer.
   - Drawer-undo: neemt het verwijderen zelf over (capture-fase) zodat theme.js
     de body niet opnieuw opbouwt en de strook op zijn plek blijft staan.
   Het item wordt direct echt verwijderd zodat afrekenen altijd klopt; bij
   "Ongedaan maken" wordt het opnieuw toegevoegd. */
(function () {
  'use strict';
  var WINDOW = 8000;

  function focusSafe(el) {
    if (!el || !el.focus) return;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }

  function announce(message) {
    if (message && window.IMHAnnounce) window.IMHAnnounce(message);
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function sourceSelector(element) {
    if (!element || !element.matches) return '';
    if (element.matches('[data-cart-minus], [data-dir="down"]')) return '[data-cart-minus], [data-dir="down"]';
    if (element.matches('[data-cart-plus], [data-dir="up"]')) return '[data-cart-plus], [data-dir="up"]';
    if (element.matches('.cart-line__remove, [data-cart-remove]')) return '.cart-line__remove, [data-cart-remove]';
    return '';
  }

  function nearbyFocus(slot, nextSlot, previousSlot) {
    var selector = 'button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled])';
    var candidates = [nextSlot, previousSlot];
    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i] && candidates[i].isConnected) {
        var found = candidates[i].matches && candidates[i].matches(selector)
          ? candidates[i]
          : candidates[i].querySelector && candidates[i].querySelector(selector);
        if (found) return found;
      }
    }
    var owner = slot.closest('.drawer, form, main') || document;
    var fallbacks = owner.querySelectorAll('[data-drawer-close], [name="checkout"], a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled])');
    for (var j = 0; j < fallbacks.length; j++) {
      if (!slot.contains(fallbacks[j])) return fallbacks[j];
    }
    return null;
  }

  function undoIcon() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M3 7v6h6"/><path d="M3.5 13a9 9 0 1 0 2.2-6.4L3 9"/></svg>';
  }

  /* Vervangt de inhoud van een slot (een cart-line) door de herstel-strook.
     opts: { title, windowMs, onUndo, onExpire } */
  function mountRow(slot, opts) {
    opts = opts || {};
    var winMs = opts.windowMs || WINDOW;
    var prevHTML = slot.innerHTML;
    var prevClass = slot.className;
    var active = document.activeElement;
    var hadFocus = slot.contains(active);
    var preferred = sourceSelector(active);
    var nextSlot = slot.nextElementSibling;
    var previousSlot = slot.previousElementSibling;
    var title = opts.title || 'Product';
    slot.removeAttribute('aria-busy');
    slot.setAttribute('data-undo-pending', '1');
    slot.className = 'cart-undo-row';
    slot.innerHTML =
      '<span class="cart-undo-row__icon">' + undoIcon() + '</span>' +
      '<div class="cart-undo-row__text"><b>' + escapeHtml(title) + '</b> verwijderd' +
      '<span>Bedacht je je? Zet het terug.</span></div>' +
      '<button type="button" class="cart-undo-row__btn">Ongedaan maken</button>' +
      '<span class="cart-undo-row__bar"><i></i></span>';
    var undoButton = slot.querySelector('.cart-undo-row__btn');
    if (hadFocus) focusSafe(undoButton);
    announce(title + ' verwijderd. Ongedaan maken is ' + Math.ceil(winMs / 1000) + ' seconden beschikbaar.');
    var bar = slot.querySelector('.cart-undo-row__bar i');
    bar.style.transitionDuration = winMs + 'ms';
    void bar.offsetWidth;
    requestAnimationFrame(function () { slot.classList.add('is-counting'); });

    var done = false;
    var timer = setTimeout(expire, winMs);

    function restore() {
      slot.className = prevClass;
      slot.innerHTML = prevHTML;
      slot.removeAttribute('data-undo-pending');
      if (hadFocus) {
        var target = preferred ? slot.querySelector(preferred) : null;
        focusSafe(target || slot.querySelector('.cart-line__remove, [data-cart-remove], button, a[href], input'));
      }
    }
    function undo() {
      if (done) return; done = true;
      clearTimeout(timer);
      hadFocus = hadFocus || slot.contains(document.activeElement);
      if (opts.onUndo) opts.onUndo(restore);
      announce(title + ' wordt teruggezet in de winkelwagen.');
    }
    function expire() {
      if (done) return; done = true;
      clearTimeout(timer);
      slot.classList.add('is-leaving');
      setTimeout(function () {
        var moveFocus = slot.contains(document.activeElement);
        var target = moveFocus ? nearbyFocus(slot, nextSlot, previousSlot) : null;
        if (opts.onExpire) opts.onExpire(slot);
        if (moveFocus) window.requestAnimationFrame(function () { focusSafe(target); });
      }, 300);
    }
    undoButton.addEventListener('click', undo);
    return { undo: undo, expire: expire };
  }

  window.ImhUndo = { mountRow: mountRow, WINDOW: WINDOW };

  /* ---------- Drawer ---------- */
  var drawer = document.getElementById('CartDrawer');

  function money(c) {
    return (window.Shopify && Shopify.formatMoney && window.themeMoneyFormat)
      ? Shopify.formatMoney(c, window.themeMoneyFormat)
      : '\u20ac' + (c / 100).toFixed(2).replace('.', ',');
  }

  function syncDrawer(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
      var button = el.closest('[data-drawer-open="CartDrawer"]');
      if (button) button.setAttribute('aria-label', 'Winkelwagen, ' + cart.item_count + (cart.item_count === 1 ? ' artikel' : ' artikelen'));
    });
    var foot = document.getElementById('CartDrawerFoot');
    if (foot) {
      var t = foot.querySelector('[data-cart-total]');
      if (t) t.textContent = money(cart.total_price);
    }
    var body = document.getElementById('CartDrawerBody');
    if (!body) return;
    var threshold = parseInt(body.dataset.freeShip || 0, 10);
    var localThreshold = parseInt(body.dataset.localThreshold || 0, 10);
    var localRadius = parseInt(body.dataset.localRadius || 10, 10);
    var prog = body.querySelector('.cart-progress');
    if (prog && threshold > 0) {
      var localPending = localThreshold > 0 && cart.total_price < localThreshold;
      var target = localPending ? localThreshold : threshold;
      var pct = Math.min(100, (cart.total_price / target) * 100);
      var remain = threshold - cart.total_price;
      var localRemain = localThreshold - cart.total_price;
      var fill = prog.querySelector('.cart-progress__fill');
      if (fill) fill.style.width = pct + '%';
      var p = prog.querySelector('p');
      if (p) {
        if (localPending) {
        p.textContent = 'Nog ' + money(localRemain) + ' tot lokale bezorging binnen ' + localRadius + ' km \ud83c\udf3f';
        } else if (remain > 0) {
          p.textContent = 'Lokale bezorging binnen ' + localRadius + ' km is beschikbaar. Nog ' + money(remain) + ' tot bezorging buiten ' + localRadius + ' km \ud83c\udf3f';
        } else {
          p.textContent = 'Je komt in aanmerking voor bezorging aan huis \ud83c\udf3f';
        }
      }
    }
  }

  function drawerEmpty() {
    var foot = document.getElementById('CartDrawerFoot');
    if (foot) foot.hidden = true;
    var body = document.getElementById('CartDrawerBody');
    if (body) body.innerHTML = '<div class="cart-empty"><div class="cart-empty__icon">\ud83e\udeb4</div><h3>Je winkelwagen is leeg</h3><p>Ontdek onze planten en voeg je favorieten toe.</p><a class="btn" href="/collections/all" data-drawer-close>Bekijk planten</a></div>';
  }

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var line = e.target.closest('.cart-line');
      if (!line || !line.dataset.key) return;
      var qtyEl = line.querySelector('[data-cart-qty]');
      var curQty = qtyEl ? (parseInt(qtyEl.value, 10) || 0) : 0;
      var isRemove = !!e.target.closest('.cart-line__remove');
      var isMinusToZero = !!e.target.closest('[data-cart-minus]') && curQty <= 1;
      // Alleen overnemen wanneer dit de regel verwijdert (Verwijderen, of - naar 0).
      if (!isRemove && !isMinusToZero) return;
      // Neem het verwijderen over zodat theme.js de body niet herbouwt.
      e.preventDefault();
      e.stopImmediatePropagation();

      var key = line.dataset.key;
      var titleEl = line.querySelector('.cart-line__title');
      var snap = {
        id: key.split(':')[0],
        quantity: curQty || 1,
        title: titleEl ? titleEl.textContent.trim() : 'Product'
      };
      line.setAttribute('aria-busy', 'true');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function (r) { return r.json(); }).then(function (cart) {
        syncDrawer(cart);
        mountRow(line, {
          title: snap.title,
          onUndo: function (restore) {
            restore();
            line.setAttribute('aria-busy', 'true');
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: snap.id, quantity: snap.quantity })
            }).then(function () { return fetch('/cart.js'); })
              .then(function (r) { return r.json(); }).then(function (cart) {
                var it = cart.items.filter(function (i) { return String(i.variant_id) === String(snap.id); })[0];
                if (it) line.dataset.key = it.key;
                syncDrawer(cart);
                line.removeAttribute('aria-busy');
                announce(snap.title + ' is teruggezet in de winkelwagen.');
              }).catch(function () { window.location.reload(); });
          },
          onExpire: function (slot) {
            slot.remove();
            var body = document.getElementById('CartDrawerBody');
            if (body && !body.querySelector('.cart-line, .cart-undo-row')) drawerEmpty();
          }
        });
      }).catch(function () {
        line.removeAttribute('aria-busy');
        window.location.reload();
      });
    }, true);
  }

  /* ---------- Bezorgmoment inklapbaar (drawer + winkelwagenpagina) ---------- */
  var bezorgPanelIndex = 0;
  function enhanceBezorg() {
    var boxes = document.querySelectorAll('[data-imh-bezorgweek]');
    Array.prototype.forEach.call(boxes, function (box) {
      if (box._imhCollapse) return;
      box._imhCollapse = true;
      box.classList.add('js-collapsible');
      var head = box.querySelector('[data-imh-bw-toggle]');
      var panel = box.querySelector('.imh-bw__panel');
      var summary = box.querySelector('[data-imh-bw-summary]');
      var status = box.querySelector('[data-imh-bw-status]');
      if (head && panel) {
        bezorgPanelIndex += 1;
        panel.id = 'imh-bw-panel-' + bezorgPanelIndex;
        head.setAttribute('aria-controls', panel.id);
      }
      function setOpen(open) {
        box.classList.toggle('is-open', open);
        if (head) head.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (panel) {
          panel.hidden = !open;
          panel.toggleAttribute('inert', !open);
        }
      }
      setOpen(true);
      if (head) head.addEventListener('click', function () {
        setOpen(!box.classList.contains('is-open'));
      });
      function mirror() {
        if (!summary || !status) return;
        var t = (status.textContent || '').replace(/^\s*Gekozen:\s*/i, '').trim();
        if (!t) return;
        summary.textContent = t.charAt(0).toUpperCase() + t.slice(1);
      }
      mirror();
      if (status && 'MutationObserver' in window) {
        new MutationObserver(mirror).observe(status, { childList: true, characterData: true, subtree: true });
      }
    });
  }
  enhanceBezorg();
  if (document.body && 'MutationObserver' in window) {
    new MutationObserver(enhanceBezorg).observe(document.body, { childList: true, subtree: true });
  }
})();
